// "Sep 30, 2026" (or "September 30, 2026") from "2026-09-30", read as a
// calendar date with no timezone shift: a page dated the 30th never shows as
// the 29th. Used by News and the college pages.
export function formatCalendarDate(iso, month = 'short') {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
        month, day: 'numeric', year: 'numeric', timeZone: 'UTC',
    });
}

// A calendar date with no time ("2026-11-30", how the knowledge base and the
// roadmap store deadlines) as LOCAL midnight of that day. `new Date('2026-11-30')`
// is UTC midnight, which every US timezone renders as the 29th: the Essay
// Workshop showed the UC deadline as Nov 29 while the Roadmap said Nov 30
// (#3028). A value carrying a time is a real instant and parses as before.
// null when the value is missing or not a date ("Rolling", "Varies").
const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseCalendarDate(value) {
    if (value === null || value === undefined || value === '') return null;
    const s = String(value).trim();
    const m = DATE_ONLY_RE.exec(s);
    const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
}

// parseCalendarDate, formatted ("Nov 30"); null when there is no date to show.
export function formatCalendarDay(value, options = { month: 'short', day: 'numeric' }) {
    const d = parseCalendarDate(value);
    return d ? d.toLocaleDateString('en-US', options) : null;
}
